import Industry from '@/service/industry'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getallcategorys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.getallcategorys(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addcategory(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.addcategory(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatecategory(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.updatecategory(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletecategory(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.deletecategory(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getcategorytemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.getcategorytemplate(payload), {
        type: 'info',
        success,
        fail
      })
    },
    updatecategorytemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.updatecategorytemplate(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getfieldh5displayexcludes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.getfieldh5displayexcludes(payload), {
        type: 'list',
        success,
        fail
      })
    },
    setfieldh5displayexcludes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.setfieldh5displayexcludes(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getcategorys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Industry.getcategorys(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
